import { createSlice ,current} from '@reduxjs/toolkit';
import { set } from "lodash"
export const entrySummarySlice = createSlice({
  name: 'entrySummary',
  initialState:{
    entrySummaryTab: {}
  },
  reducers: {
    initializeEntrySummaryTab: (state, {payload}) => {
        state.entrySummaryTab = payload
    },
    updateHeaderTab: (state, {payload: {name, value, itemId}}) => {
      set(state, `entrySummaryTab.${itemId}.${name}`, value);
    }
  }
});

export const { initializeEntrySummaryTab, updateEntrySummaryTab } = entrySummarySlice.actions;

export default entrySummarySlice.reducer;
